export default __webpack_public_path__ + "static/calendar-navigate-73f4be7ff8292391c2e95779e73935fb.mp4";